import React, { forwardRef } from 'react'

const Table = forwardRef((props, ref) => (
	<div id={props.id} 
		ref={ref}
		class={`${props.responsive ? 'table-responsive' : ''} ${props.border ? 'table-bordered' : ''} ${props.striped ? 'table-striped' : ''}`} 
		style={props.alturaFixa ? {
			display: "flex",
			overflowX: props.overflowX || "auto",
			maxHeight: props.maxHeight || "75vh",
			height: props.height,
			minWidth: props.minWidth,
			overflowY: "scroll",
			scrollBehavior: 'smooth'
		} : { 
			display: 'flex',
			overflowX: 'auto' 
		}}>
	    <table className={`table ${props.noHover ? '' : 'table-hover'} ${props.tableBordered ? 'table-bordered' : ''}`}
			style={{ marginBottom: props.marginBottom, minWidth: props.scroolHorizontal ? 'max-content' : null }}>
			{props.children}
		</table>
	</div>
));

export default Table;
